import React, { Component } from 'react';
import withAuth from './../auth_components/js/withAuth';
import AuthService from './../auth_components/js/AuthService';
import { Link } from 'react-router-dom'

import './css/homepage.css';
import './css/home-directory.css';
import MenuBook from '@material-ui/icons/MenuBook'
import Person from '@material-ui/icons/Person'
import SupervisorAccount from '@material-ui/icons/SupervisorAccount'
import AccountBalanceWallet from '@material-ui/icons/AccountBalanceWallet'
import AddAlert from '@material-ui/icons/AddAlert'
import CloudDownload from '@material-ui/icons/CloudDownload'
import CreditCard from '@material-ui/icons/CreditCard'
import Receipt from '@material-ui/icons/Receipt'
import Settings from '@material-ui/icons/Settings'


const feesPayment = {
  title: 'Fees Payment',
  description: 'Collect fees and print receipts',
  path: '/fees',
  icon: <AccountBalanceWallet />
}

const superadminGroups = [
  {
    title: 'Records',
    modules: [
      {
        title: 'Students',
        description: 'Find and update student records',
        path: '/students',
        icon: <Person />
      },
      {
        title: 'Employee',
        description: 'Staff records and leave',
        path: '/employees',
        icon: <SupervisorAccount />
      },
      {
        title: 'Masters',
        description: 'Courses and other master lists',
        path: '/masters/course',
        icon: <MenuBook />
      }
    ]
  },
  {
    title: 'Fees and requests',
    modules: [
      feesPayment,
      {
        title: 'ID Card Requests',
        description: 'Review and print student ID cards',
        path: '/idcard-requests',
        icon: <CreditCard />
      },
      {
        title: 'Receipt Reprints',
        description: 'Reprint paid admission receipts',
        path: '/admission-print-requests',
        icon: <Receipt />
      }
    ]
  },
  {
    title: 'Office',
    modules: [
      {
        title: 'Notifications',
        description: 'Post notices for students',
        path: '/notifications',
        icon: <AddAlert />
      },
      {
        title: 'Backup',
        description: 'Download a copy of the database',
        path: '/backup',
        icon: <CloudDownload />
      },
      {
        title: 'Settings',
        description: 'Service switches and your password',
        path: '/settings',
        icon: <Settings />
      }
    ]
  }
]

const adminGroups = [
  {
    title: 'Fees',
    modules: [feesPayment]
  }
]

class HomePage extends Component {
  state = {
    version: ''
  }
  Auth = new AuthService();

  logout = () => {
    this.Auth.logout();
    this.props.history.replace('/login')
  }

  componentDidMount() {
    fetch(`/meta.json`)
    .then(resp => resp.json())
    .then((resp) => {
      this.setState({
        version: resp.version
      })
    })
  }

  render() {
    const groups = this.Auth.getRole() == "SUPERADMIN" ? superadminGroups : adminGroups;

    return (
      <div className="hd-page">
        <header className="hd-banner">
          <div className="hd-wrap hd-account">
            <span>{this.props.user.user.name}</span>
            <button type="button" className="hd-logout" onClick={this.logout}>Logout</button>
          </div>

          <div className="hd-wrap hd-identity">
            <h1 className="hd-wordmark" lang="as">ৰঙিয়া কলেজ</h1>
            <p className="hd-name">Rangia College</p>
          </div>
        </header>

        <main className="hd-wrap hd-directory">
          {groups.map((group) => (
            <section key={group.title}>
              <h2 className="hd-group">{group.title}</h2>
              {group.modules.map((module) => (
                <Link key={module.path} to={module.path} className="hd-module">
                  <span className="hd-module__icon">{module.icon}</span>
                  <span>
                    <span className="hd-module__title">{module.title}</span>
                    <span className="hd-module__description">{module.description}</span>
                  </span>
                </Link>
              ))}
            </section>
          ))}
        </main>

        {this.state.version != '' && (
          <footer className="hd-wrap hd-version">Version {this.state.version}</footer>
        )}
      </div>
    )
  }
}

export default withAuth(HomePage);
